/**
 * Computes the ratio of canvas pixels to CSS pixels. The units are canvas
 * pixels divided by CSS pixels. In the ideal this would be the same as the
 * devicePixelRatio global.
 */
export const getDisplayScale = (canvas: HTMLCanvasElement) => {
    if (canvas.clientWidth > 0) {
        return canvas.width / canvas.clientWidth;
    } else {
        return 1;
    }
};
